
/**
 * Smooth scroll to an element
 * @param elId - The id of the element to scroll to
 * @returns A function to handle the click event
 */
export function useSmoothScroll(elId: string) {
  const handleClick = () => {
    const el = document.getElementById(elId)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return handleClick
}
